<onyx-modal
  variant="right"
  heading="labels.realizationSummary"
  [close$]="close$"
  (closeModal)="dialogRef.close()"
>
  <ng-container description>
    <span class="f-muted">
      @if (data.orderIdentifier; as identifier) {
        <onyx-link
          color="gray"
          font="f-body-l f-link"
          (click)="openOrderModal()"
        >
          {{ identifier }}
        </onyx-link>
        ·
      }

      @if (RouteHelper.isTechnicalPoint(data.point)) {
        {{
          `${DictionaryCode.TECHNICAL_POINT_CATEGORY}.${data.point.category}`
            | translate
        }}
      } @else {
        {{
          `${DictionaryCode.ORDER_POINT_TYPE}.${data.point.type}` | translate
        }}
      }

      @if (data.typeIndex != null) {
        {{ data.typeIndex }}
      }
    </span>
  </ng-container>

  <div class="container">
    <div class="handling-history">
      @let point = data.point;
      @let startedAt = point.timestamps.startedAt;
      @let driverReports = point.driverReports;
      @let completed = driverReports?.completed;
      @let inProgress = driverReports?.['in-progress'];

      @if (driverReports?.waiting; as waiting) {
        <ng-container
          *ngTemplateOutlet="
            headingSectionTemplate;
            context: {
              report: waiting,
              heading: 'labels.waiting',
              start: waiting.createdAt,
              finish: inProgress?.createdAt ?? startedAt,
            }
          "
        ></ng-container>
      }

      @if (inProgress) {
        <ng-container
          *ngTemplateOutlet="
            headingSectionTemplate;
            context: {
              report: inProgress,
              heading: RouteHelper.isTechnicalPoint(point)
                ? `${DictionaryCode.TECHNICAL_POINT_CATEGORY}.${point.category}`
                : `${DictionaryCode.ORDER_POINT_TYPE}.${point.type}`,
              start: inProgress.createdAt,
              finish: completed?.createdAt ?? point.timestamps.completedAt,
            }
          "
        ></ng-container>

        @if (inProgressFiles().length) {
          <ng-container
            *ngTemplateOutlet="
              filesContainerTemplate;
              context: { files: inProgressFiles() }
            "
          ></ng-container>
        }
      }

      @if (completed) {
        <onyx-information-list>
          <onyx-information-row label="labels.driver">
            @if (driverHelper.hasModule()) {
              <button class="f-link" (click)="openDriverModal()">
                {{ completed.author | onyxName }}
              </button>
            } @else {
              {{ completed.author | onyxName }}
            }
          </onyx-information-row>

          @if (completed.didntParticipate != null) {
            <onyx-information-row
              [label]="`${I18N}.participeIn${isLoadingPoint() ? 'Loading' : 'Unloading'}`"
            >
              {{
                (completed.didntParticipate ? 'labels.no' : 'labels.yes')
                  | translate
              }}
            </onyx-information-row>
          }

          @if (completed.hasPalletsExchanged != null) {
            <onyx-information-row label="labels.hasPalletExchange">
              {{
                `labels.${completed.hasPalletsExchanged ? 'yes' : 'no'}`
                  | translate
              }}
            </onyx-information-row>
          }

          @if (completed.partnersDetails; as partnersDetails) {
            <onyx-information-row
              [label]="`labels.${isLoadingPoint() ? 'sender' : 'recipient'}`"
            >
              <div class="sender">
                <p>{{ partnersDetails | onyxName }}</p>

                @if (partnersDetails.phone; as phone) {
                  {{ phone | onyxPhone }}
                } @else {
                  <p class="f-muted">
                    {{ 'labels.missingPhone' | translate }}
                  </p>
                }
              </div>
            </onyx-information-row>
          }
        </onyx-information-list>

        @if (completed.note; as note) {
          <onyx-data-widget supheading="labels.note" [gap]="4" [padding]="8">
            {{ note }}
          </onyx-data-widget>
        }

        <ng-container
          *ngTemplateOutlet="
            filesContainerTemplate;
            context: { files: completedFiles(), showEmpty: true }
          "
        ></ng-container>
      }
    </div>
  </div>
</onyx-modal>

<ng-template
  let-files="files"
  let-showEmpty="showEmpty"
  #filesContainerTemplate
>
  <div class="files-container">
    @for (item of files; track item) {
      @if (item.files.length) {
        <app-driver-report-modal-image
          [filesData]="files"
          [files]="item.files"
          [title]="item.title"
          [note]="item.note"
        ></app-driver-report-modal-image>
      }
    } @empty {
      @if (showEmpty) {
        {{ 'labels.noFiles' | translate }}
      }
    }
  </div>
</ng-template>

<ng-template
  let-report="report"
  let-heading="heading"
  let-start="start"
  let-finish="finish"
  #headingSectionTemplate
>
  <div class="item">
    <h6>
      {{ heading | translate }}

      <span class="f-muted">
        {{ start | onyxTime }}-{{ finish | onyxTime }} ·
        {{ start | onyxDate: 'date' : { endDate: finish } }}
      </span>
    </h6>

    @if (report.note; as note) {
      <onyx-data-widget supheading="labels.note" [gap]="4" [padding]="8">
        {{ note }}
      </onyx-data-widget>
    } @else {
      <p class="f-muted">{{ 'labels.missingNote' | translate }}</p>
    }
  </div>
</ng-template>
